import { CUSTOMER_EVENTS } from './customerEventValues'

export const CUSTOMER_LABEL = {
  [CUSTOMER_EVENTS.NA]: '-',
  [CUSTOMER_EVENTS.NOT_AVAIL]: '-',
  [CUSTOMER_EVENTS.REPAIRED]: 'Engineer Repaired',
  [CUSTOMER_EVENTS.FAILED_REPAIR]: 'Failed Repair',
  [CUSTOMER_EVENTS.CUST_REPAIRED]: 'Customer Repaired',
  [CUSTOMER_EVENTS.ENG_VISIT]: 'Engineer Visit',
  [CUSTOMER_EVENTS.ENG_VISIT_NO_LEAK]: 'Engineer Visit No Leak',
  [CUSTOMER_EVENTS.COMP_REPAIR]: 'Complete Repair',
  [CUSTOMER_EVENTS.FAILED_CUST_REPAIR]: 'Failed Customer Repair',
  [CUSTOMER_EVENTS.COMP_CUST_REPAIR]: 'Complete Customer Repaired',
  [CUSTOMER_EVENTS.CANCEL_BOOKING]: 'Cancel Booking',
  [CUSTOMER_EVENTS.NULL]: '-'
}
